import parse from "date-fns/parse";
import format from "date-fns/format";
import { PackageAvailabilityDto } from "../dtos";
import dinero, { Dinero } from "dinero.js";
import { prepPrice } from "../../utils";

export class PackageAvailability {
  private dtoFormat = "yyyy-MM-dd HH:mm:ss";
  dateFormat = "dd-MM-yyyy";
  timeFormat = "HH:mm";

  date = new Date();
  dateStr = "";
  timeStr = "";
  reservationData: {
    price: { person_type_id: number; price: number; vat: number }[];
    activities: {
      activity_id: number;
      slots: {
        slot_id: number;
        capacity: number;
        instance_start_time: string; // "2020-12-22 15:00:00";
        instance_end_time: string; // "2020-12-22 15:00:00";
        slot_order: number;
      }[];
    }[];
  } = { price: [], activities: [] };
  totalTax: Dinero = dinero();
  totalPrice: Dinero = dinero();

  constructor(dto: PackageAvailabilityDto & { date: string }) {
    const date = parse(dto.date, this.dtoFormat, this.date);
    this.date = date;
    this.dateStr = format(date, this.dateFormat);
    this.timeStr = format(date, this.timeFormat);
    this.reservationData = {
      price: dto.price,
      activities: dto.activities,
    };

    // For packages with capacity price equal 1 system person type
    this.totalPrice = dto.price.reduce((acc, { price }) => {
      const priceWrapped = dinero({ amount: prepPrice(price) });
      return acc.add(priceWrapped);
    }, dinero());

    // TODO: calculate VAT on API side
    this.totalTax = dto.price.reduce((acc, { vat }) => {
      const vatWrapped = dinero({ amount: prepPrice(vat) });
      return acc.add(vatWrapped);
    }, dinero());
  }
}
